var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sankeyContainer"},[_c('div',{ref:"sankeyChart",staticStyle:{"width":"100%","height":"700px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }